const i = "_divider_aoxk9_1", d = {
  divider: i,
  "divider--margin": "_divider--margin_aoxk9_7"
};
export {
  d as default,
  i as divider
};
